// document.addEventListener('DOMContentLoaded', function () {
//   let activeModal = null;
//   const modalDefaultStates = new Map(); // Store default states of modals

//   // Attach event listener using event delegation
//   document.body.addEventListener('click', function (evt) {
//     if (evt.target.classList.contains('custom-quickview')) {
//       const button = evt.target;

//       const handle = button.dataset.handle;
//       const modalId = button.dataset.modal;
//       const modal = document.querySelector(`modal-dialog#${modalId}`);

//       if (modal) {
//         if (!modalDefaultStates.has(modalId)) {
//           // Save the default state of the modal if not already saved
//           modalDefaultStates.set(modalId, modal.innerHTML);
//         }

//         const wrapper = modal.querySelector('.quick-view');
//         console.log(`Opening modal with ID: ${modalId}`);
//         if (wrapper) {
//           activeModal = modal;
//           showLoader(wrapper);
//           fetchProductData(handle, wrapper);
//         }
//       }
//     }
//   });

//   // Observer to detect modal close and reset its state
//   const observer = new MutationObserver(() => {
//     if (!document.body.classList.contains('overflow-hidden') && activeModal) {
//       console.log('Popup closed. Resetting modal to default state...');
//       resetModalToDefaultState(activeModal);
//       activeModal = null;
//     }
//   });
//   observer.observe(document.body, { attributes: true, attributeFilter: ['class'] });

//   function fetchProductData(handle, wrapper) {
//     fetch(`/products/${handle}`)
//       .then((response) => response.text())
//       .then((data) => {
//         const parser = new DOMParser();
//         const doc = parser.parseFromString(data, 'text/html');

//         // Replace relevant blocks
//         ['price', 'apps', 'variant-picker', 'add_to_cart', 'json'].forEach((attribute) => {
//           replaceBlockContent(doc, wrapper, attribute);
//         });

//         initializeSwiper(wrapper);
//         attachVariantListeners(wrapper, handle);
//       })
//       .catch((error) => console.error('Error fetching product data:', error))
//       .finally(() => hideLoader(wrapper));
//   }

//   function attachVariantListeners(wrapper, handle) {
//     const variantInputs = wrapper.querySelectorAll('input[type="radio"]');
//     cleanupListeners(wrapper);

//     variantInputs.forEach((input) => {
//       input.addEventListener('change', function onVariantChange() {
//         const selectedValues = getSelectedValues(wrapper);

//         const dataSelectedVariant = wrapper.querySelector('[data-selected-variant-custom]');
//         if (!dataSelectedVariant) return;

//         const jsonString = dataSelectedVariant.textContent;
//         const { id: variantId } = findVariantId(jsonString, selectedValues);
//         if (variantId) {
//           fetchVariantData(handle, variantId, wrapper);
//         }
//       });
//     });

//     wrapper._variantInputs = variantInputs; // Store inputs for cleanup
//   }

//   function cleanupListeners(wrapper) {
//     if (wrapper?._variantInputs) {
//       wrapper._variantInputs.forEach((input) => {
//         input.replaceWith(input.cloneNode(true)); // Remove all attached event listeners
//       });
//       wrapper._variantInputs = null;
//     }
//   }

//   function fetchVariantData(handle, variantId, wrapper) {
//     showLoader(wrapper);
//     fetch(`/products/${handle}?variant=${variantId}`)
//       .then((response) => response.text())
//       .then((data) => {
//         const parser = new DOMParser();
//         const newDoc = parser.parseFromString(data, 'text/html');

//         ['price', 'apps', 'variant-picker', 'add_to_cart', 'json'].forEach((attribute) => {
//           replaceBlockContent(newDoc, wrapper, attribute);
//         });

//         attachVariantListeners(wrapper, handle);
//       })
//       .catch((error) => console.error('Error fetching variant data:', error))
//       .finally(() => hideLoader(wrapper));
//   }

//   function replaceBlockContent(sourceDoc, targetWrapper, attribute) {
//     const newBlock = sourceDoc.querySelector(`[data-fetch="${attribute}"]`);
//     const existingBlock = targetWrapper.querySelector(`[data-fetch="${attribute}"]`);

//     if (existingBlock) {
//       existingBlock.innerHTML = newBlock?.innerHTML.trim() || `<span class="placeholder">Content not available</span>`;
//     }
//   }

//   function resetModalToDefaultState(modal) {
//     const modalId = modal.getAttribute('id');
//     if (modalDefaultStates.has(modalId)) {
//       modal.innerHTML = modalDefaultStates.get(modalId);
//       console.log(`Modal with ID ${modalId} reset to default state.`);
//     }
//   }

//   function getSelectedValues(wrapper) {
//     const selectedValues = {};
//     const inputs = wrapper.querySelectorAll('input[type="radio"]:checked, select');

//     inputs.forEach((input) => {
//       const optionName = input.name.split('-')[0].trim();
//       selectedValues[optionName] = input.value;
//     });
//     return selectedValues;
//   }

//   function findVariantId(jsonString, selectedValues) {
//     try {
//       const parsedData = JSON.parse(jsonString);
//       const variants = Array.isArray(parsedData) ? parsedData : parsedData.variants || [parsedData];

//       const matchedVariant = variants.find((variant) =>
//         Object.keys(selectedValues).every((key, index) =>
//           variant[`option${index + 1}`] === selectedValues[key]
//         )
//       );

//       return matchedVariant ? { id: matchedVariant.id } : { id: null };
//     } catch (error) {
//       console.error('Error parsing variants JSON:', error.message);
//       return { id: null };
//     }
//   }

//   function showLoader(wrapper) {
//     const loader = document.createElement('div');
//     loader.className = 'loading-overlay';
//     loader.innerHTML = '<div class="spinner"></div>';
//     wrapper.appendChild(loader);
//   }

//   function hideLoader(wrapper) {
//     const loader = wrapper.querySelector('.loading-overlay');
//     if (loader) loader.remove();
//   }

//   function initializeSwiper(wrapper) {
//     const swiperElement = wrapper.querySelector('.quick-view__swiper');
//     if (swiperElement) {
//       new Swiper(swiperElement, {
//         spaceBetween: 2,
//         navigation: {
//           nextEl: '.swiper-button-next',
//           prevEl: '.swiper-button-prev',
//         },
//         pagination: {
//           el: '.swiper-pagination',
//           clickable: true,
//         },
//       });
//     }
//   }
// });
document.addEventListener('DOMContentLoaded', function () {
  let activeModal = null;
  const modalDefaultStates = new Map(); // Store default states of modals

  // Attach event listeners directly to buttons

  document.body.addEventListener('click', function (evt) {
    if (evt.target.classList.contains('custom-quickview')) {
      const button = evt.target;
      const handle = button.dataset.handle;
      const modalId = button.dataset.modal;
      const modal = document.querySelector(`modal-dialog#${modalId}`);

      if (modal) {
        if (!modalDefaultStates.has(modalId)) {
          // Save the default state of the modal if not already saved
          modalDefaultStates.set(modalId, modal.innerHTML);
        }

        const wrapper = modal.querySelector('.quick-view');
        console.log(`Opening modal with ID: ${modalId}`);
        if (wrapper) {
          activeModal = modal;
          showLoader(wrapper);
          fetchProductData(handle, wrapper);
        }
      }
    }
  });

  // Observer to detect modal close and reset its state
  const observer = new MutationObserver(() => {
    if (!document.body.classList.contains('overflow-hidden') && activeModal) {
      console.log('Popup closed. Resetting modal to default state...');
      resetModalToDefaultState(activeModal);
      activeModal = null;
    }
  });
  observer.observe(document.body, { attributes: true, attributeFilter: ['class'] });

  function fetchProductData(handle, wrapper) {
    fetch(`/products/${handle}`)
      .then((response) => response.text())
      .then((data) => {
        const parser = new DOMParser();
        const doc = parser.parseFromString(data, 'text/html');

        // Replace relevant blocks
        ['price', 'apps', 'variant-picker', 'add_to_cart', 'json'].forEach((attribute) => {
          replaceBlockContent(doc, wrapper, attribute);
        });

        initializeSwiper(wrapper);
        attachVariantListeners(wrapper, handle);
      })
      .catch((error) => console.error('Error fetching product data:', error))
      .finally(() => hideLoader(wrapper));
  }

  function attachVariantListeners(wrapper, handle) {
    if (!wrapper) return;
    cleanupListeners(wrapper);
  
    const variantInputs = wrapper.querySelectorAll('input[type="radio"], select');
    variantInputs.forEach((input) => {
      input.addEventListener('change', () => {
        const selectedValues = getSelectedValues(wrapper);
        const dataSelectedVariant = wrapper.querySelector('[data-selected-variant-custom]');
        if (!dataSelectedVariant) return;
  
        const jsonString = dataSelectedVariant.textContent;
        const { id: variantId } = findVariantId(jsonString, selectedValues);
        if (variantId) {
          fetchVariantData(handle, variantId, wrapper);
        }
      });
    });
    wrapper._variantInputs = variantInputs;
  
    wrapper.addEventListener('click', (e) => {
      const toggle = e.target.closest('.variant-dropdown__toggle');
      if (toggle) {
        const menu = wrapper.querySelector(`#${toggle.getAttribute('aria-controls')}`);
        if (!menu) return;
  
        const open = menu.hidden;
        menu.hidden = !open;
        toggle.setAttribute('aria-expanded', String(open));
        return;
      }
  
      const item = e.target.closest('.variant-dropdown__item');
      if (!item) return;
      if (item.disabled || item.getAttribute('aria-disabled') === 'true' || item.classList.contains('is-disabled')) return;
  
      const menu = item.closest('.variant-dropdown__menu');
      const wrap = menu.closest('.variant-dropdown');
      const select = wrap.querySelector('select.select__select');
  
      select.value = item.dataset.value;
      select.dispatchEvent(new Event('change', { bubbles: true }));
    });
  
    document.addEventListener('click', (e) => {
      const openMenu = wrapper.querySelector('.variant-dropdown__menu:not([hidden])');
      if (openMenu && !e.target.closest('.variant-dropdown')) {
        openMenu.hidden = true;
        const toggle = openMenu.closest('.variant-dropdown')?.querySelector('.variant-dropdown__toggle');
        if (toggle) toggle.setAttribute('aria-expanded', 'false');
      }
    });
  }
  
  function cleanupListeners(wrapper) {
    if (wrapper?._variantInputs) {
      wrapper._variantInputs.forEach((input) => {
        input.replaceWith(input.cloneNode(true)); // Remove all attached event listeners
      });
      wrapper._variantInputs = null;
    }
  }

  function fetchVariantData(handle, variantId, wrapper) {
    showLoader(wrapper);
    fetch(`/products/${handle}?variant=${variantId}`)
      .then((response) => response.text())
      .then((data) => {
        const parser = new DOMParser();
        const newDoc = parser.parseFromString(data, 'text/html');

        ['price', 'apps', 'variant-picker', 'add_to_cart', 'json'].forEach((attribute) => {
          replaceBlockContent(newDoc, wrapper, attribute);
        });

        attachVariantListeners(wrapper, handle);
      })
      .catch((error) => console.error('Error fetching variant data:', error))
      .finally(() => hideLoader(wrapper));
  }

  function replaceBlockContent(sourceDoc, targetWrapper, attribute) {
    const newBlock = sourceDoc.querySelector(`[data-fetch="${attribute}"]`);
    const existingBlock = targetWrapper.querySelector(`[data-fetch="${attribute}"]`);

    if (existingBlock) {
      existingBlock.innerHTML = newBlock?.innerHTML.trim() || `<span class="placeholder">Content not available</span>`;
    }
  }

  function resetModalToDefaultState(modal) {
    const modalId = modal.getAttribute('id');
    if (modalDefaultStates.has(modalId)) {
      modal.innerHTML = modalDefaultStates.get(modalId);
      console.log(`Modal with ID ${modalId} reset to default state.`);
    }
  }

  function getSelectedValues(wrapper) {
    const selectedValues = {};
    const inputs = wrapper.querySelectorAll('input[type="radio"]:checked, select');

    inputs.forEach((input) => {
      const optionName = input.name.split('-')[0].trim();
      selectedValues[optionName] = input.value;
    });
    return selectedValues;
  }

  function findVariantId(jsonString, selectedValues) {
    try {
      const parsedData = JSON.parse(jsonString);
      const variants = Array.isArray(parsedData) ? parsedData : parsedData.variants || [parsedData];

      const matchedVariant = variants.find((variant) =>
        Object.keys(selectedValues).every((key, index) =>
          variant[`option${index + 1}`] === selectedValues[key]
        )
      );

      return matchedVariant ? { id: matchedVariant.id } : { id: null };
    } catch (error) {
      console.error('Error parsing variants JSON:', error.message);
      return { id: null };
    }
  }

  function showLoader(wrapper) {
    const loader = document.createElement('div');
    loader.className = 'loading-overlay';
    loader.innerHTML = '<div class="spinner"></div>';
    wrapper.appendChild(loader);
  }

  function hideLoader(wrapper) {
    const loader = wrapper.querySelector('.loading-overlay');
    if (loader) loader.remove();
  }

  function initializeSwiper(wrapper) {
    const swiperElement = wrapper.querySelector('.quick-view__swiper');
    if (swiperElement) {
      new Swiper(swiperElement, {
        spaceBetween: 2,
        navigation: {
          nextEl: '.swiper-button-next',
          prevEl: '.swiper-button-prev',
        },
        pagination: {
          el: '.swiper-pagination',
          clickable: true,
        },
      });
    }
  }
});

